<template>
	<div class="dialog draggable-item bg-light light w-100-sm w-100-md w-75-lg w-50-xl">
		<div class="dialog-title pl-10 d-flex flex-align-center">
			<span class="mif-receipt mr-2"></span>
			<span class="flex-1">
				{{ $t("Invoice") }} {{ invoice.external_invoice_id || ('#' + invoice.id) }}
			</span>
			<span class="badge inline mr-3" :class="invoice.invoiced ? 'success' : 'warning'">
				{{ invoice.invoiced ? $t("Invoiced") : $t("Not invoiced") }}
			</span>
			<span class="button square closer" @click="$root.$emit('CLOSEINVOICEVIEW')"></span>
		</div>

		<div class="dialog-content overflow p-3">
			<InvoiceTemplate :invoice="invoice" />
		</div>

		<div class="dialog-actions p-3 border-top text-right py-4">
			<button class="button" :disabled="exporting" @click="exportInvoiceAs(invoice, 'pdf')">
				<span v-if="exporting == 'pdf'" class="mif-spinner2 ani-spin mr-1"></span>
				<span v-else class="mif-file-pdf mr-1"></span>
				{{ $t("Export PDF") }}
			</button>
			<button class="button ml-2" :disabled="exporting" @click="exportInvoiceAs(invoice, 'xlsx')">
				<span v-if="exporting == 'xlsx'" class="mif-spinner2 ani-spin mr-1"></span>
				<span v-else class="mif-file-excel mr-1"></span>
				{{ $t("Export XLSX") }}
			</button>
			<button v-if="!invoice.invoiced" class="button success ml-2" @click="markInvoiced">
				<span class="mif-checkmark mr-1"></span>{{ $t("Mark as invoiced") }}
			</button>
			<button class="button ml-2" @click="$root.$emit('CLOSEINVOICEVIEW')">{{ $t("Close") }}</button>
		</div>
	</div>
</template>

<script>
import { populateUsefulMaps } from '../../../utils/entityMethods/ticket';
import InvoiceTemplate from './InvoiceTemplate.vue';
import { invoiceExportMixin } from '../../../mixins/invoiceExport';

export default {
	name: "InvoiceView",
	components: { InvoiceTemplate },
	mixins: [invoiceExportMixin],
	props: {
		invoice: {
			type: Object,
			required: true
		}
	},
	async mounted() {
		await this.populateUsefulMaps();

	},
	methods: {
		populateUsefulMaps,
		async markInvoiced() {
			const result = await this.$api.markInvoice(this.invoice.id);
			if (result == null) return;
			this.$root.$emit("refreshInvoices");
			this.$root.$emit("CLOSEINVOICEVIEW");
		}
	}
};
</script>

<style scoped>
.flex-1 {
	flex: 1;
}
</style>
